import React from "react";
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  IconButton,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";
import CodeReview from "images/business/code-review.svg";
import Building from "images/business/building.svg";
import Teaching from "images/business/teaching.svg";
import InternationalMarket from "images/business/international-market.svg";
import BgTitle from "components/title/BgTitle";

export default ({
  systemEngRef,
  reinforcementRef,
  leaseRef,
  chineseMarketRef,
}) => {
  const { t } = useTranslation();

  const businessItems = [
    {
      imageSrc: CodeReview,
      title: t("business.ses.heading"),
      description: t("business.ses.description"),
      reference: systemEngRef,
    },
    {
      imageSrc: Building,
      title: t("business.reinforcement.heading"),
      description: t("business.reinforcement.description"),
      reference: reinforcementRef,
    },
    {
      imageSrc: Teaching,
      title: t("business.lease-of-pc.heading"),
      description: t("business.lease-of-pc.description"),
      reference: leaseRef,
    },
    {
      imageSrc: InternationalMarket,
      title: t("business.chineseMarketSupport.heading"),
      description: t("business.chineseMarketSupport.description"),
      reference: chineseMarketRef,
    },
  ];

  const scrollToTarget = (targetRef) => {
    if (targetRef.current) {
      const offset = 80;
      const targetPosition =
        targetRef.current.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box sx={{ pb: 2 }}>
      <Container sx={{ px: 0 }}>
        {/* Header */}
        <Box display={"flex"} justifyContent={"center"}>
          <BgTitle text={t("business.subheading")} isCenter={true} />
        </Box>

        {/* Business List */}
        <List sx={{ pt: 1 }}>
          {businessItems.map((item, index) => (
            <ListItem
              key={index}
              onClick={() => scrollToTarget(item.reference)}
              sx={{
                px: 3,
                py: 2.5,
                gap: 2,
                "&:active": {
                  bgcolor: "action.selected",
                },
                cursor: "pointer",
                "&:not(:last-child)": {
                  borderBottom: "1px solid",
                  borderColor: "divider",
                },
              }}
            >
              {/* Image */}
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: 2,
                  overflow: "hidden",
                  flexShrink: 0,
                  bgcolor: "grey.100",
                }}
              >
                <Box
                  component="img"
                  src={item.imageSrc}
                  alt={item.title}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>

              {/* Content */}
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 650,
                    fontSize: "0.8rem",
                    color: "text.primary",
                  }}
                >
                  {item.title}
                </Typography>
              </Box>

              {/* Arrow Icon */}
              <IconButton
                edge="end"
                sx={{
                  color: "primary.main",
                  ml: 1,
                }}
              >
                <ChevronRightIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Container>
    </Box>
  );
};
